export const appointments = (state) => {
  return state.appointments ? state.appointments : []
}

export const canEditAppointments = (state) => {
  return state.canEditAppointments
}
